module.exports = __webpack_public_path__ + "static/full-garden-f97ba1bd7c30445150b373dd86143f65.jpg";